// extracted by mini-css-extract-plugin
export var blue__btn = "style-module--blue__btn--60486";
export var cost = "style-module--cost--49b54";
export var cost__bg = "style-module--cost__bg--748fc";
export var cost__blockBtn = "style-module--cost__block-btn--d6fd3";
export var cost__col = "style-module--cost__col--6c4d2";
export var cost__colUnderblock = "style-module--cost__col-underblock--a39e2";
export var cost__colUnderblocks = "style-module--cost__col-underblocks--214ff";
export var cost__priceColor = "style-module--cost__price-color--6a0c7";
export var cost__priceOrange = "style-module--cost__price-orange--b9c09";
export var cost__priceText = "style-module--cost__price-text--24fd2";
export var cost__row = "style-module--cost__row--06d0b";
export var cost__wrapper = "style-module--cost__wrapper--0e1af";
export var orangeBtn = "style-module--orange-btn--1c0fa";
export var perMonth = "style-module--per-month--930aa";